import { FORTEM_URIS } from '@/constants/uris'
import { BondsDataRecPage } from '@/pages/trading/bonds-data-rec/page'
import { BookedTradesPage } from '@/pages/trading/booked-trades/page'
import { DataUploadPage } from '@/pages/trading/data-upload/page'
import { TradingLayout } from '@/pages/trading/layout'
import { BookTradePage } from '@/pages/trading/new-trade/page'
import type { CustomRouteObject, FortemRouteHandle } from '@/router'

export const tradingRoutes = [
  {
    path: 'trading',
    element: <TradingLayout />,
    handle: {
      title: 'Trading',
    },
    children: [
      {
        index: true,
        element: <BookedTradesPage />,
        handle: {
          title: 'All Trades',
        },
      },
      {
        path: FORTEM_URIS.TRADING.NEW_TRADE,
        element: <BookTradePage />,
      },
      {
        path: FORTEM_URIS.TRADING.BONDS_DATA_REC,
        element: <BondsDataRecPage />,
      },
      {
        path: FORTEM_URIS.TRADING.DATA_UPLOAD,
        element: <DataUploadPage />,
      },
    ],
  },
] satisfies CustomRouteObject<FortemRouteHandle>[]
